import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Compbaser } from "../../../components/compbaser";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { AccessService, AppService, StoreSelectorsService, UserService } from "../../../services";
import { copyTextClipboard, isFalsy } from "../../../common";
import { TranslocoService } from "@ngneat/transloco";
import { Lib } from "../../../../libs/Lib";
import { SceneMimeTypes } from "../../editor/scene-blocks/mime-constants";
import { SceneSelectorComponent } from "../../../components/scene-selector/scene-selector.component";
import { StationRegCodeComponent } from "./station-reg-code/station-reg-code.component";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
    selector: "app-station-add-player",
    templateUrl: "./station-add-player.component.html",
    styleUrls: ["./station-add-player.component.scss"],
})
export class StationAddPlayerComponent extends Compbaser implements OnInit {
    sceneId: string;
    playerName = "new player";
    codeReady = false;
    loading = false;
    enterprise = false;
    mimeType = "";
    signStudioProducts$: Observable<string>;

    @ViewChild("regCode", { static: false }) regCode: StationRegCodeComponent;
    @ViewChild("sceneSelector", { static: false }) sceneSelector: SceneSelectorComponent;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public override dialog: MatDialog,
        private toastr: ToastrService,
        private translocoService: TranslocoService,
        private storeSelector: StoreSelectorsService,
        private userService: UserService,
        private router: Router,
        private appService: AppService,
        private accessService: AccessService,
    ) {
        super();
        this.sceneId = this.data.sceneId;
        this.signStudioProducts$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navProducts ? value.$.navProducts : "1"));
    }

    static createDialog(i_dialog, i_sceneId = null) {
        i_dialog.open(StationAddPlayerComponent, {
            width: "500px",
            data: {
                sceneId: i_sceneId,
            },
        });
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                this.enterprise = Lib.GetAccountVersion(user) === "ENTERPRISE_08" || Lib.GetAccountVersion(user) === "ENTERPRISE_24";
            }));

        this.mimeType = SceneMimeTypes.Player;
    }

    openOnSale() {
        this.appService.openOnSaleDialog();
    }

    copyInstallPlayerLink() {
        copyTextClipboard("http://install.signage.me/");
        this.toastr.info("link copied", "");
    }


    selectScene(event) {
        this.sceneId = event;
    }

    onCodeReady(event) {
        this.codeReady = event;
    }

    addPlayer() {
        this.loading = true;
        this.cod(
            this.userService.registerStationFromCode(
                this.regCode.getCode(),
                this.sceneId,
                this.playerName,
            )
                .subscribe((data) => {
                    this.loading = false;
                    if (!data) {
                        this.toastr.warning(this.translocoService.translate("toast.sorryEncounteredProblemSave", {}, this.translocoService.getActiveLang()));
                        return;
                    }
                    if (!data.status || isFalsy(data.status)) {
                        if (data.error === "Code not exist") {
                            data.error = "Sorry the code entered does not exist, try again...";
                        }
                        if (data.error === "exceeded") {
                            data.error = "Number of licenses has already been reached. Please contact your admin.";
                        }
                        this.toastr.warning(data.error || "sorry, failed to add player.");
                    } else {
                        this.toastr.success("added player successfully.");
                        setTimeout(() => {
                            this.dialog.closeAll();
                            this.router.navigateByUrl("/stations");
                        }, 333);
                    }
                }),
        );
    }

    onClose() {
        this.dialog.closeAll();
    }
}
